import { TableCell } from "@mui/material";
import React from "react";
import { toast } from "react-toastify";
import HuntStrategyChancesTable from "../../Order/HuntChances/HuntStrategyChancesTable";
import Modal from "../../../Components/Modal/Modal";
import Button from "../../../Components/Button";
import { OrderStrategy } from "../../../Interfaces/orderInterfaces";
import TableTemplate, { IAdditional } from "../../TableTemplate/tableTemplate";
import BrokerOrdersTable from "../../Step/BrokerOrder/BrokerOrdersTable";
import { IDeltaHedgeOrderTableReport } from "../../../Interfaces/deltaHedgeOrder";
import {
  getDeltaHedgeOrderBrokerTradeTable,
  getDeltaHedgeOrderTradeChancesTable,
} from "../../../Requests/deltaHedgeOrder";
import { CommonTableUI } from "../../TableTemplate/common";

const AdditionalHeader: React.FC = () => {
  return (
    <>
      <TableCell></TableCell>
      <TableCell></TableCell>
      <TableCell></TableCell>
    </>
  );
};

const AdditionalCol: React.FC<{
  row: IDeltaHedgeOrderTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [isChancesOpen, setIsChancesOpen] = React.useState(false);
  const [isBrokerOrdersModalOpen, setIsBrokerOrdersModalOpen] =
    React.useState(false);

  function errorHandler(e: any) {
    let error: any;

    if (!e) error = "خطا در ارتباط با سرور";
    if (e.msg) error = e.msg;
    if (e?.response?.data?.value) error = e.response.data.value;
    toast.error(error);
  }

  const btnClickHandler = () => {
    setIsChancesOpen(true);
  };

  return (
    <>
      <TableCell>
        {isBrokerOrdersModalOpen ? (
          <Modal
            UI={
              <TableTemplate<{ id: number }, any>
                refreshTableTime={5000}
                getDataTable={(_, offset, pageSize) =>
                  getDeltaHedgeOrderBrokerTradeTable(
                    { id: row.id },
                    offset,
                    pageSize
                  )
                }
                TableUI={({ reports, onAction }) => (
                  <CommonTableUI reports={reports} onAction={onAction} />
                )}
              />
            }
            onClose={() => setIsBrokerOrdersModalOpen(false)}
          />
        ) : null}
        <Button
          onClick={() => setIsBrokerOrdersModalOpen(true)}
          text="سفارشات"
          variant="contained"
          className="table-btn"
        />
      </TableCell>

      <TableCell>
        {isChancesOpen ? (
          <Modal
            UI={
              <HuntStrategyChancesTable
                getData={(_, offset, pageSize) =>
                  getDeltaHedgeOrderTradeChancesTable(
                    { id: row.id },
                    offset,
                    pageSize
                  )
                }
              />
            }
            onClose={() => setIsChancesOpen(false)}
          />
        ) : null}
        <Button
          onClick={btnClickHandler}
          text="شانس ها"
          variant="contained"
          className="table-btn"
        />
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<IDeltaHedgeOrderTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
